import React from 'react';
import { Paper } from 'material-ui';
import CompanyWithLocs from './displayCompanyWithLocs';

const Follows = ({ follows }) => {
  return (
    <div style={{ width: '50%', margin: 'auto' }}>
      {
        follows.map((companyWithLocs, index) => {
          return (
            <Paper key={companyWithLocs.companyId} style={{ marginTop: '24px' }}>
              {index + 1}: <CompanyWithLocs {...companyWithLocs}/>
            </Paper>
          );
        })
      }
    </div>);
};

export default Follows;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/ownerMetaDataPages/follows.jsx